export const useManagementOpinionInfo = (managementOpinion, i18n) => {
	const mapRequestInfo = () => {
		return [
			{
				title: i18n`Requested By`,
				text: managementOpinion?.creationUser?.name || '-',
				icon: 'profile',
			},
			{
				title: i18n`Reason`,
				text: managementOpinion?.submittedMedicalRequest || '-',
				icon: 'info',
			},
		]
	}

	const mapResponseInfo = () => {
		return [
			{
				title: i18n`Submitted by`,
				text: managementOpinion?.responseUser?.name || '-',
				icon: 'profile',
			},
			{
				title: i18n`Date`,
				text: managementOpinion?.responseDate?.shortDateFormat || '-',
				icon: 'calendar',
			},
			{
				title: i18n`Opinion Request`,
				text: managementOpinion?.medicalOpinionResult || '-',
				icon: 'info',
			},
		]
	}

	return {
		getRequestDetails: mapRequestInfo,
		getResponseDetails: mapResponseInfo,
	}
}
